export default "__VITE_ASSET__CsKKUrIk__"